import { faFilter } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode, useMemo } from 'react';
import { BadgeConfig, BadgeIcon } from 'shared/badge_icon/BadgeIcon';
import type { CSSProp } from 'styled-components';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const FilterPaneContainer = styled.div<{ $containerStyles?: CSSProp }>`
    display: flex;
    gap: 0.8rem;
    align-items: center;
    ${({ $containerStyles }) => $containerStyles}
`;

export type FilterPaneProps = Readonly<{
    id: string;
    /**
     * The total number of filters applied
     */
    filterCount?: number;
    /**
     * Content to render in the filter pane
     */
    children: ReactNode;
    /**
     * Optional styles to override the container styles
     */
    containerStyles?: CSSProp;
}>;

export function FilterPane({
    id,
    filterCount,
    children,
    containerStyles,
}: FilterPaneProps) {
    const badgeConfig = useMemo<BadgeConfig | undefined>(
        () =>
            filterCount && filterCount !== 0
                ? {
                      count: filterCount,
                      textColor: tokens.on.primary,
                      backgroundColor: tokens.text.link,
                  }
                : undefined,
        [filterCount],
    );

    return (
        <FilterPaneContainer id={id} $containerStyles={containerStyles}>
            <BadgeIcon
                icon={<FontAwesomeIcon icon={faFilter} className="f-16" />}
                badge={badgeConfig}
            />
            {children}
        </FilterPaneContainer>
    );
}
